module.exports = __webpack_public_path__ + "static/media/nut-cat.6409546e.JPG";